import { extractConfig, applyServerDefaults, type WidgetConfig } from './config'
import { fetchWidgetConfig } from './api/backend'
import { HolostaffWidget } from './widget'

// Auto-bootstrap: find the script tag that loaded us and extract config
function bootstrap(): void {
  const scriptEl = document.currentScript as HTMLScriptElement | null
    ?? document.querySelector<HTMLScriptElement>('script[data-staff-id]')

  if (!scriptEl) {
    console.error('[HolostaffWidget] Could not find script tag with data-staff-id')
    return
  }

  try {
    const config = extractConfig(scriptEl)

    async function initWidget() {
      let finalConfig = config
      let widgetPrompts: string[] | null = null
      let serverConfig: Awaited<ReturnType<typeof fetchWidgetConfig>> | null = null

      // Fetch server config to get RTDB-stored defaults + widgetPrompts
      try {
        serverConfig = await fetchWidgetConfig(config.staffId, config.backendUrl)
        finalConfig = applyServerDefaults(config, scriptEl!, serverConfig)
        widgetPrompts = serverConfig.widgetPrompts
      } catch (err) {
        console.warn('[HolostaffWidget] Failed to fetch server config, using embed defaults:', err)
      }

      const widget = new HolostaffWidget(finalConfig, widgetPrompts)

      // Set idle asset URLs from server config
      if (serverConfig?.idleVideoUrl) widget.setIdleVideo(serverConfig.idleVideoUrl)
      else if (serverConfig?.avatarImageUrl) widget.setIdleImage(serverConfig.avatarImageUrl)

      // Set staff display info for chat-again pill
      if (serverConfig) {
        widget.setStaffInfo(serverConfig.name, serverConfig.avatarImageUrl)
      }

      // Expose API on window for external control
      ;(window as any).holostaffWidget = widget

      widget.init()
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initWidget())
    } else {
      initWidget()
    }
  } catch (err) {
    console.error('[HolostaffWidget]', err)
  }
}

bootstrap()

export { HolostaffWidget }
export type { WidgetConfig }
